import ReactDOM from 'react-dom/client';
import App from './App';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router";
import { AllData } from './Data/AllData';
import ScrollToTop from 'react-scroll-to-top';
import Properties from './Properties';
import Details from './Details';
import Contact from './Contact';
import Products from './Products';
import SingleProduct from './SingleProductPage/SingleProduct';
import Cart from './Cart';

let router = createBrowserRouter([
  {
    path: "/",
    element: <App />
  }, {
    path: "properties",
    element: <Properties />
  }, {
    path: "details",
    element: <Details />
  }, {
    path: "contact",
    element: <Contact />
  }, {
    path: "products",
    element: <Products />
  }, {
    path: "singleProduct/:id",
    element: <SingleProduct />
  }, {
    path: "cart",
    element: <Cart />
  },
]);

ReactDOM.createRoot(document.getElementById('root')).render(
  <AllData>
    <ScrollToTop smooth />
    <RouterProvider router={router} />
  </AllData>

);

